export default {
    GET_RESERVATION_REQUEST: 'RESERVATION_EDIT_OVERVIEW_GET_RESERVATION_REQUEST',
    GET_RESERVATION_SUCCESS: 'RESERVATION_EDIT_OVERVIEW_GET_RESERVATION_SUCCESS',
    UPDATE_RESERVATION_OVERVIEW_REQUEST: 'RESERVATION_EDIT_OVERVIEW_UPDATE_RESERVATION_REQUEST',
    UPDATE_RESERVATION_OVERVIEW_SUCCESS: 'RESERVATION_EDIT_OVERVIEW_UPDATE_RESERVATION_SUCCESS',
    DISPOSE: 'RESERVATION_EDIT_OVERVIEW_DISPOSE_STORE',
};
